import TicketApi from "../api/service/ticket/TicketApi";

export default class TicketService {
    api;

    constructor() {
        this.api = new TicketApi();
    }

    async getTicketList({ page, pageSize, remained }) {
        return this.api.getTicketList({ page, pageSize, remained }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getTicketDetail({ ticketNo }) {
        return this.api.getTicketDetail({ ticketNo }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async saveTicket(reqDto) {
        return this.api.saveTicket(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async updateTicket(reqDto) {
        return this.api.updateTicket(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async deleteTicket({ ticketNo }) {
        return this.api.deleteTicket({ ticketNo }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async uploadTicketImage({ ticketNo, content }) {
        return this.api.uploadTicketImage({ ticketNo, content }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async deleteTicketImage({ idTicketImage }) {
        return this.api.deleteTicketImage({ idTicketImage }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getTicketStatus() {
        return this.api.getTicketStatus().then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getTicketTrend({ periodType, today }) {
        return this.api.getTicketTrend({ periodType, today }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
